module.exports = __webpack_public_path__ + "static/media/practice-question-header.1ce1e9ac.png";